import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getBasisType,
  createChargeBasis,
} from "../../../ReduxStore/Slice/Pricing/ChargeBasisSlice";
import sweatalert from "sweetalert2";
import {
  EMPTY_CHARGE_BASIS_NAME_ERROR,
  EMPTY_MIN_BAND_BASIS_ERROR,
  EMPTY_FREQUENCY_NAME_ERROR,
  EMPTY_PRICING_QUERY,
} from "../../../Utils/Common_Error";

const CreateChargebasis = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const agent_db = localStorage.getItem("agent_db");
 
  const token = localStorage.getItem("token");
  const [getBasisTypeData, setGetBasisTypeData] = useState([]);

  const [status, setStatus] = useState("1");
  const [increment, setIncrementType] = useState("0");
  const [selfAssessment, setSelfAssessment] = useState("0");

  const [formData, setFormData] = useState({
    name: "",
    basistypes_id: getBasisTypeData?.[0]?.id || "",
  });
  const [errors, setErrors] = useState({});
  const [selectedType, setSelectedType] = useState("");
  const [bands, setBands] = useState([{ min: "", max: "" }]);
  const [frequencyBands, setFrequencyBands] = useState([{ value1: "" }]);
  const [pricingQury, setPricingQuer] = useState("");
  const [pquryType, setPquryType] = useState("");

  useEffect(() => {
    GetBasisType();
  }, []);

  

  const GetBasisType = async () => {
    const req = { token: token, agent_id: agent_id };
    try {
      const res = await dispatch(getBasisType(req)).unwrap();
      if (res.status) {
        if(['prelivecrm_latest','staging_group','livednsgroup'].includes(agent_db)){
          setGetBasisTypeData(res.data);
        }else{
          setGetBasisTypeData(res.data.filter((item) => item.id !== 5));
        }
      } else {
        setGetBasisTypeData([]);
      }
    } catch (err) {
      console.log("Error in getting Basis Type", err);
    }
  };

  useEffect(() => {
    if (getBasisTypeData?.length > 0) {
      setSelectedType(getBasisTypeData[0].id);
    }
  }, [getBasisTypeData]);

  const handleSelectChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedType(selectedId);
  };

  useEffect(() => {
    setBands([{ value1: "" }]);
  }, [selectedType]);

  const handleAdd = () => {
    setBands([...bands, { min: "", max: "" }]);
  };

  const handleRemove = (index) => {
    const updated = bands.filter((_, i) => i !== index);
    setBands(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...bands];
    updated[index][field] = value;
    setBands(updated);
  };

  const handleAdd1 = () => {
    setFrequencyBands([...frequencyBands, { value1: "" }]);
  };

  const handleRemove1 = (indexToRemove) => {
    const updatedBands = frequencyBands.filter(
      (_, idx) => idx !== indexToRemove
    );
    setFrequencyBands(updatedBands);
  };

  const handleChange1 = (index, key, val) => {
    const updatedBands = [...frequencyBands];
    updatedBands[index][key] = val;
    setFrequencyBands(updatedBands);
  };

  // useEffect(() => {
  //   setFrequencyBands([{ value1: "" }]);
  // }, [selectedType]);

  const handlePquryType = (e) => {
    const value = e.target.value;
    setPquryType(value);
  };

  useEffect(() => {
    setFrequencyBands([{ value1: "" }]);
    if (selectedType === 1) {
      setPquryType("input");
    } else if (selectedType === 5) {
      setPquryType("radio");
    } else {
      setPquryType("");
    }
  }, [selectedType]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = EMPTY_CHARGE_BASIS_NAME_ERROR;
    } else if (selectedType !== 2 && !pricingQury?.trim()) {
      newErrors.pricingQury = EMPTY_PRICING_QUERY;
    } else {
      if (selectedType === 3) {
        bands.forEach((band, index) => {
          if (!band.min?.trim()) {
            newErrors[`band-${index}`] = EMPTY_MIN_BAND_BASIS_ERROR;
          }
        });
      }

      if (selectedType === 4) {
        frequencyBands.forEach((band, index) => {
          if (!band.value1?.trim()) {
            newErrors[`freqBand-${index}`] = EMPTY_FREQUENCY_NAME_ERROR;
          }
        });
      }
    }

    setErrors(newErrors);
 

    if (Object.keys(newErrors).length === 0) {
      let req = {
        name: formData.name,
        basistypes_id: selectedType,
        agent_id: agent_id,
        status: status,
        incremental_price: increment,
        pricing_queries: pricingQury,
        pricing_queries_type: pquryType,
        self_assessment: selfAssessment,
        chargetype:
          selectedType === 3
            ? bands.map((b) =>
                b.max?.trim() ? `${b.min}-${b.max}` : `${b.min}`
              )
            : selectedType === 4
            ? frequencyBands.map((b) => `${b.value1}`)
            : [],
      };

      // return

      await dispatch(createChargeBasis(req))
        .unwrap()
        .then((res) => {
          if (res.status) {
            sweatalert.fire({
             
              title: "Success",
              text: res.msg,
              icon: "success",
              timer: 3000,
            });
            navigate("/admin/pricing/all-charge-basis");
          } else {
            sweatalert.fire({
              title: "Error",
             text:res.msg,
              icon: "error",
              timer: 3000,
            });
          }
        })
        .catch((err) => {
          console.log("Error in creating charge basis", err);
        });
    }
  };

  const addBands = () => {
    setBands((prev) => [
      ...prev,
      {
        min: "",
        max: "",
      },
    ]);
  };

  const removeBands = (index) => {
    const updated = [...bands];
    updated.splice(index, 1);

    setBands(updated);
  };

  return (
    <>
      <div className="row mb-4">
        <div className="col">
          <h4 className="page-title">
            <Link to="/admin/pricing/all-charge-basis">
              <i className="bx bx-arrow-back text-pink"></i>
            </Link>{" "}
            Charge Basis
          </h4>
        </div>
      </div>
      <div className="card form-card">
        <div className="card-header d-sm-flex justify-content-between align-items-center">
          <div>
            <h5 className="card-title mb-0">Create Charge Basis</h5>
          </div>

          <div className="">
            <div className="d-flex justify-content-sm-center  justify-content-lg-start align-items-center">
              <label htmlFor="status" className=" col-form-label py-0">
                Status:
              </label>

              <div className="form-switch ms-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="statusSwitch"
                  checked={status === "1"}
                  onChange={() =>
                    setStatus((prev) => (prev === "1" ? "0" : "1"))
                  }
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card-body px-0 px-lg-3">
          <form>
            <div className="">
              <div className="row px-2">
                <div className="col-md-6 mb-3">
                  <div className="row justify-content-sm-center  justify-content-lg-start">
                    <label className="col-form-label col-sm-3" htmlFor="name">
                      Name of charge basis:
                    </label>
                    <div className=" col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        autocomplete="off"
                        placeholder="Enter Name of charge basis"
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                      />
                      {errors.name && formData.name.trim() === "" && (
                        <div
                          style={{
                            color: "#ff00a2",
                            fontSize: "0.875rem",
                            marginTop: "0.25rem",
                          }}
                        >
                          {errors.name}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="row justify-content-sm-center justify-content-lg-start">
                    <label
                      className="col-form-label col-sm-3"
                      htmlFor="basistypes_id"
                    >
                      Type:
                    </label>
                    <div className="col-sm-9">
                      <select
                        className="default-select wide form-select"
                        id="basistypes_id"
                        name="basistypes_id"
                        defaultValue={getBasisTypeData?.[0]?.id || ""}
                        onChange={handleSelectChange}
                      >
                        {getBasisTypeData?.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {selectedType !== 2 && (
                  <>
                    <div className="col-md-6 mb-3">
                      <div className="row justify-content-sm-center  justify-content-lg-start">
                        <label
                          className="col-form-label col-sm-3"
                          htmlFor="name"
                        >
                          Pricing Queries:
                        </label>
                        <div className=" col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            id="pqury"
                            autocomplete="off"
                            name="pqury"
                            placeholder="Enter Pricing Queries"
                            value={pricingQury}
                            onChange={(e) => setPricingQuer(e.target.value)}
                          />
                          {errors.pricingQury && pricingQury.trim() === "" && (
                            <div
                              style={{
                                color: "#ff00a2",
                                fontSize: "0.875rem",
                                marginTop: "0.25rem",
                              }}
                            >
                              {errors.pricingQury}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {selectedType !== 3 && selectedType !== 4 && (
                      <div className="col-md-6 mb-3">
                        <div className="row justify-content-sm-center justify-content-lg-start">
                          <label
                            className="col-form-label col-sm-3"
                            htmlFor="basistypes_id"
                          >
                            Type:
                          </label>
                          <div className="col-sm-9">
                            <select
                              className="default-select wide form-select"
                              id="basistypes_id"
                              name="basistypes_id"
                              value={pquryType}
                              onChange={handlePquryType}
                              disabled
                            >
                              <option value="">Select Type</option>
                              <option value="radio">Radio</option>
                              <option value="input">Input</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {(selectedType === 1 || selectedType === 5) && (
                  <>
                    {selectedType === 5 && (
                      <div className="col-md-4 mb-3">
                        <div className="row justify-content-sm-center  justify-content-lg-start align-items-center">
                          <label
                            htmlFor="status"
                            className="col-sm-4 col-form-label"
                          >
                            Incremental Price:
                          </label>
                          <div className="col-sm-7">
                            <div className="form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="status"
                                onChange={() =>
                                  setIncrementType((prev) =>
                                    prev === "1" ? "0" : "1"
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="col-md-5 mb-3">
                      <div className="row justify-content-sm-center  justify-content-lg-start align-items-center">
                        <label
                          htmlFor="status1"
                          className="col-sm-4 col-form-label"
                        >
                          Self Assessment Applicability:
                        </label>
                        <div className="col-sm-7 ps-1">
                          <div className="form-switch ">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="status1"
                              onChange={() =>
                                setSelfAssessment((prev) =>
                                  prev === "1" ? "0" : "1"
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {selectedType === 3 && (
                <div className="gray-card">
                  {bands.map((band, index) => (
                    <div
                      className="row  mb-2 w-100 mx-auto"
                      key={index}
                    >
                      <div className="col d-flex justify-content-between ">
                        <label className="mb-0  col-form-label col-2">
                          Set default band:
                        </label>

                        <div className="w-100 ms-5 me-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Min Value"
                            value={band.min}
                            onChange={(e) =>
                              handleChange(index, "min", e.target.value)
                            }
                          />
                          {!band.min && errors[`band-${index}`] && (
                            <div
                              style={{
                                color: "#ff00a2",
                                fontSize: "0.875rem",
                                marginTop: "0.25rem",
                              }}
                            >
                              {errors[`band-${index}`]}
                            </div>
                          )}
                        </div>

                        <div className="w-100">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Max Value"
                            value={band.max}
                            onChange={(e) =>
                              handleChange(index, "max", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div className="col d-flex justify-content-end align-items-center">
                       
                          <span
                            className={`fs-2 ${
                              index === bands.length - 1
                                ? "text-pink"
                                : "text-danger"
                            }`}
                          >
                            {index === bands.length - 1 ? (
                           <>
                           {bands.length != 1 && (
                            <i className="fa-regular fa-circle-minus fs-2 text-pink d-block plusMinus-circle"
                            onClick={() =>
                              handleRemove(index)
                            }
                            ></i>


                           )}
                           <i className="fa-regular fa-circle-plus fs-2 mt-4 text-pink d-block plusMinus-circle"   onClick={() =>
                              handleAdd(index)
                            }></i>
                           </>
                            ) : (
                              <i className="fa-regular fa-circle-minus fs-2 text-pink d-block plusMinus-circle"   onClick={() =>
                              handleRemove(index) 
                            }></i>
                            )}
                          </span>
                  
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {selectedType === 4 && (
                <div
                  className="gray-card"
                  style={{ backgroundColor: "#fafafa" }}
                >
                  {frequencyBands.map((band, index) => (
                    <div
                      className="row  mb-2 mx-auto "
                      key={index}
                    >
                      <div className="col d-flex justify-content-between ">
                        <label className=" col-form-label">
                          Frequency Type:
                        </label>

                        <div className="col ms-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Frequency Name"
                            value={band.value1}
                            onChange={(e) =>
                              handleChange1(index, "value1", e.target.value)
                            }
                          />
                          {!band.value1 && errors[`freqBand-${index}`] && (
                            <div
                              style={{
                                color: "#ff00a2",
                                fontSize: "0.875rem",
                                marginTop: "0.25rem",
                              }}
                            >
                              {errors[`freqBand-${index}`]}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col text-end d-flex align-items-center justify-content-end">
                      
                          <span
                            className={`fs-2 ${
                              index === frequencyBands.length - 1
                                ? "text-pink"
                                : "text-danger"
                            }`}
                          >
                            {index === frequencyBands.length - 1 ? (
                              <>
                                {frequencyBands.length != 1 && (
                                  <i className="fa-regular d-block fa-circle-minus fs-2 text-pink plusMinus-circle"
                                    onClick={() =>
                                      handleRemove1(index)
                                    }
                                  ></i>
                                )}

                                <i className="fa-regular d-block fa-circle-plus  mt-3 fs-2 text-pink plusMinus-circle" 
                                onClick={() =>
                                  handleAdd1(index)}
                                ></i>
                              </>
                            ) : (
                              <i className="fa-regular d-block fa-circle-minus fs-2 text-pink plusMinus-circle"
                              onClick={() =>
                                handleRemove1(index)
                              }
                              ></i>
                            )}
                          </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="text-end mt-4 mb-0">
                <button
                  type="button"
                  className="btn btn-outline-secondary rounded "
                  onClick={() => window.history.back()}
                >
                  <i className="fa fa-xmark" /> Cancel
                </button>
                <button
                  className="btn btn-pink rounded ms-2"
                  type="button"
                  onClick={handleSubmit}
                >
                  <i className="far fa-save" /> Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateChargebasis;
